import React from "react";
import { Modal } from "react-bootstrap";
import "../Home/Home.scss";

export default function Popup({ show, onHide, children }) {
  return (
    <Modal show={Boolean(show)} onHide={onHide} className="add_more" animation={false}>
      {children}
    </Modal>
  );
}
